import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from 'react-router-dom';
/**
 * Returns a <Redirect /> component if the route does not have a component to render.
 * @param route
 * @param path
 */
export const OptionalRedirect = ({ route, routes, path, }) => {
    if ((route === null || route === void 0 ? void 0 : route.component) !== undefined) {
        // console.debug(path, '=> component to render ✔️');
        return null;
    }
    const routeToRedirectTo = routes[0];
    if (routeToRedirectTo === undefined) {
        // console.debug(path, '=> nothing to redirect to ❌');
        return null;
    }
    const redirectPath = `${path}${routeToRedirectTo.path}`;
    if (route === undefined) {
        // console.debug(path, `=> <Redirect from="" to="${redirectPath}"/> ✨`);
        return _jsx(Redirect, { exact: true, from: "", to: redirectPath }, void 0);
    }
    // console.debug(path, `=> <Redirect from="${path}" to="${redirectPath}"/> ✨`);
    return _jsx(Redirect, { exact: true, from: path, to: redirectPath }, void 0);
};
//# sourceMappingURL=OptionalRedirect.js.map